// document.addEventListener("DOMContentLoaded", function () {
//   setTimeout(() => {
//     // Localiza todos os elementos <li class="bullet">
//     const bullets = document.querySelectorAll("li.bullet");

//     // Itera sobre cada bullet encontrado
//     bullets.forEach((bullet) => {
//       // Verifica se o bullet não contém uma tag <img>
//       if (!bullet.querySelector("img")) {
//         // Remove o bullet do DOM
//         bullet.remove();
//       }
//     });
//   }, 1000);
// });

// document.addEventListener("DOMContentLoaded", function () {
//   const slider = new KeenSlider(".keen-slider", {
//     loop: true,
//     duration: 1000,
//     spacing: 20,
//     dragStart: () => {
//       autoPlay.clear();
//     },
//     dragEnd: () => {
//       autoPlay.play();
//     },
//   });

//   const autoPlay = {
//     play: () => {
//       autoPlay.interval = setInterval(() => {
//         slider.next();
//       }, 5000);
//     },
//     pause: () => {
//       clearInterval(autoPlay.interval);
//     },
//     clear: () => {
//       clearInterval(autoPlay.interval);
//     },
//   };

//   autoPlay.play();
// });

// increment and decrement quantity
// document.addEventListener("DOMContentLoaded", function () {
//   const minusBtn = document.querySelector(".quantity-btn.minus");
//   const plusBtn = document.querySelector(".quantity-btn.plus");
//   const quantityInput = document.querySelector(".quantity-input");

//   minusBtn.addEventListener("click", function (e) {
//     e.preventDefault();
//     const currentValue = parseInt(quantityInput.value);
//     if (currentValue > 1) {
//       quantityInput.value = currentValue - 1;
//     }
//   });

//   plusBtn.addEventListener("click", function (e) {
//     e.preventDefault();
//     const currentValue = parseInt(quantityInput.value);
//     const maxValue = parseInt(quantityInput.getAttribute("max"));
//     if (currentValue < maxValue) {
//       quantityInput.value = currentValue + 1;
//     }
//   });
// });

// Carroussel
// let counter = 1;
// const slide = document.querySelector('.carousel-slide');
// const images = document.querySelectorAll('.carousel-slide img');

// const size = images[0].clientWidth;
// slide.style.transform = 'translateX(' + (-size * counter) + 'px)';

// document.getElementById('nextBtn').addEventListener('click', () => {
//   if (counter >= images.length - 1) return;
//   slide.style.transition = "transform 0.4s ease-in-out";
//   counter++;
//   slide.style.transform = 'translateX(' + (-size * counter) + 'px)';
// });

// document.getElementById('prevBtn').addEventListener('click', () => {
//   if (counter <= 0) return;
//   slide.style.transition = "transform 0.4s ease-in-out";
//   counter--;
//   slide.style.transform = 'translateX(' + (-size * counter) + 'px)';
// });

// slide.addEventListener('transitionend', () => {
//   if (images[counter].id === 'lastClone') {
//     slide.style.transition = "none";
//     counter = images.length - 2;
//     slide.style.transform = 'translateX(' + (-size * counter) + 'px)';
//   }
//   if (images[counter].id === 'firstClone') {
//     slide.style.transition = "none";
//     counter = images.length - counter;
//     slide.style.transform = 'translateX(' + (-size * counter) + 'px)';
//   }
// });


document.addEventListener("DOMContentLoaded", function () {
  setTimeout(() => {
    // Localiza todos os elementos <li class="bullet">
    const bullets = document.querySelectorAll("li.bullet");

    // Itera sobre cada bullet encontrado
    bullets.forEach((bullet) => {
      // Verifica se o bullet não contém uma tag <img>
      if (!bullet.querySelector("img")) {
        // Remove o bullet do DOM
        bullet.remove();
      }
    });
  }, 1000);
});

document.addEventListener("DOMContentLoaded", function () {
  const slider = new KeenSlider(".keen-slider", {
    loop: true,
    duration: 1000,
    spacing: 20,
    dragStart: () => {
      autoPlay.clear();
    },
    dragEnd: () => {
      autoPlay.play();
    },
  });

  const arrowLeft = document.getElementById("arrow-left");
  const arrowRight = document.getElementById("arrow-right");

  arrowLeft.addEventListener("click", () => {
    slider.prev();
  });

  arrowRight.addEventListener("click", () => {
    slider.next();
  });

  const autoPlay = {
    play: () => {
      autoPlay.interval = setInterval(() => {
        slider.next();
      }, 5000);
    },
    pause: () => {
      clearInterval(autoPlay.interval);
    },
    clear: () => {
      clearInterval(autoPlay.interval);
    },
  };

  autoPlay.play();
});

// Carroussel
let counter = 1;
const slide = document.querySelector('.carousel-slide');
const images = document.querySelectorAll('.carousel-slide img');

const size = images[0].clientWidth;
slide.style.transform = 'translateX(' + (-size * counter) + 'px)';

document.getElementById('nextBtn').addEventListener('click', () => {
  if (counter >= images.length - 1) return;
  slide.style.transition = "transform 0.4s ease-in-out";
  counter++;
  slide.style.transform = 'translateX(' + (-size * counter) + 'px)';
});

document.getElementById('prevBtn').addEventListener('click', () => {
  if (counter <= 0) return;
  slide.style.transition = "transform 0.4s ease-in-out";
  counter--;
  slide.style.transform = 'translateX(' + (-size * counter) + 'px)';
});

slide.addEventListener('transitionend', () => {
  if (images[counter].id === 'lastClone') {
    slide.style.transition = "none";
    counter = images.length - 2;
    slide.style.transform = 'translateX(' + (-size * counter) + 'px)';
  }
  if (images[counter].id === 'firstClone') {
    slide.style.transition = "none";
    counter = images.length - counter;
    slide.style.transform = 'translateX(' + (-size * counter) + 'px)';
  }
});
